import { type SupportedLocale } from '@zep-us/i18n';
import { type QuizTypeOption } from '@/api/ai/useBuildAiQuiz';
import { useAiTrialQuotaQuery } from '@/shared/features/ai-quiz-generation/hooks';
import { SelectAiLanguage, SelectAiQuizCount, SelectAiQuizLevel, SelectAiQuizType } from './BuildOption';
import { type GenerateNumberOption, type QuizLevelOption } from './const';
import { type BuildPromptOptions } from './type';
export interface PromptOptionsSectionProps {
  options: BuildPromptOptions;
  onOptionsChange: (options: BuildPromptOptions) => void;
}

/**
 * Quiz 생성 옵션 섹션 컴포넌트
 *
 * 4개의 select 컴포넌트를 관리:
 * - Quiz 개수 (count) - 쿼터 제한 유저(비로그인/FREE)는 10개 고정, select disabled
 * - 언어 (language)
 * - Quiz 타입 (type)
 * - 난이도 (level)
 *
 * @param options - 현재 옵션 값
 * @param onOptionsChange - 옵션 변경 핸들러
 */
export const PromptOptionsSection = ({
  options,
  onOptionsChange
}: PromptOptionsSectionProps) => {
  const {
    isQuotaLimited
  } = useAiTrialQuotaQuery();
  const {
    language,
    quizType,
    quizLevel,
    quizCount
  } = options;
  const handleSelectLanguage = (language: SupportedLocale) => {
    onOptionsChange({
      ...options,
      language
    });
  };
  const handleSelectQuizLevel = (level: QuizLevelOption) => {
    onOptionsChange({
      ...options,
      quizLevel: level
    });
  };
  const handleSelectQuizType = (type: QuizTypeOption) => {
    onOptionsChange({
      ...options,
      quizType: type
    });
  };
  const handleSelectQuizCount = (count: GenerateNumberOption) => {
    // 쿼터 제한 유저는 quiz count 변경 불가 (UI에서 disabled지만 방어 로직)
    if (isQuotaLimited) {
      return;
    }
    onOptionsChange({
      ...options,
      quizCount: count
    });
  };
  return <>
      <div className="flex flex-col gap-lg tablet-sm:flex-row tablet-sm:gap-md">
        <SelectAiQuizCount selectedCount={quizCount} onSelect={handleSelectQuizCount} isQuotaLimited={isQuotaLimited} data-sentry-element="SelectAiQuizCount" data-sentry-source-file="PromptOptionsSection.tsx" />
        <SelectAiLanguage selectedLanguage={language} onSelect={handleSelectLanguage} data-sentry-element="SelectAiLanguage" data-sentry-source-file="PromptOptionsSection.tsx" />
      </div>
      <div className="flex flex-col gap-lg tablet-sm:flex-row tablet-sm:gap-md">
        <SelectAiQuizType selectedQuizType={quizType} onSelect={handleSelectQuizType} data-sentry-element="SelectAiQuizType" data-sentry-source-file="PromptOptionsSection.tsx" />
        <SelectAiQuizLevel selectedQuizLevel={quizLevel} onSelect={handleSelectQuizLevel} data-sentry-element="SelectAiQuizLevel" data-sentry-source-file="PromptOptionsSection.tsx" />
      </div>
    </>;
};